export default "<div \n  [ngClass]=\"styleClass\" \n  [innerHTML]=\"htmlContent | safeHtml\">\n</div>\n"